import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface Client {
  id: string;
  email: string;
  name: string;
  phone?: string;
  address?: string;
  company?: string;
  tax_id?: string; // RFC
  status: 'active' | 'inactive';
  user_id?: string; // ID del usuario asociado (si existe)
  projects_count?: number;
  total_invoices?: number;
  total_paid?: number;
  created_at: number;
  updated_at: number;
}

export interface CreateClientData {
  email: string;
  name: string;
  phone?: string;
  address?: string;
  company?: string;
  tax_id?: string;
  user_id?: string; // Opcional: asociar a un usuario existente
}

export interface UpdateClientData {
  name?: string;
  phone?: string;
  address?: string;
  company?: string;
  tax_id?: string;
  status?: 'active' | 'inactive';
}

export const clientService = {
  // ============================================================
  // OBTENER CLIENTES
  // ============================================================
  
  async getClients(): Promise<Client[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients`);
    return response.data || [];
  },

  async getClient(id: string): Promise<Client> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients/${id}`);
    return response.data;
  },

  // ============================================================
  // CREAR/ACTUALIZAR/ELIMINAR CLIENTE
  // ============================================================
  
  async createClient(data: CreateClientData): Promise<Client> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return response.data;
  },

  async updateClient(id: string, data: UpdateClientData): Promise<Client> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return response.data;
  },

  async deleteClient(id: string): Promise<void> {
    await authService.fetchWithAuth(`${API_URL}/api/clients/${id}`, {
      method: 'DELETE'
    });
  },

  async toggleClientStatus(id: string): Promise<Client> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients/${id}/toggle`, {
      method: 'PATCH'
    });
    return response.data;
  },

  // ============================================================
  // ESTADÍSTICAS Y REPORTES
  // ============================================================
  
  async getClientStats(): Promise<{ total: number; active: number; inactive: number }> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients/stats`);
    return response.data;
  },

  async getClientProjects(clientId: string): Promise<any[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients/${clientId}/projects`);
    return response.data || [];
  }
};